import {Routes} from "@angular/router";
import {WorkflowCspOneUpgradeCuComponent} from "./workflow-csp-one-upgrade-cu.component";

export const workflowCspOneUpgradeCuRouting: Routes = [
    { path: 'csp/upgrade-cu/:aid', component: WorkflowCspOneUpgradeCuComponent, children: [
            { path: 'address', component: WorkflowCspOneUpgradeCuComponent },
            { path: 'payment', component: WorkflowCspOneUpgradeCuComponent },
            { path: 'checkout', component: WorkflowCspOneUpgradeCuComponent },
            { path: 'complete', component: WorkflowCspOneUpgradeCuComponent },
            { path: '', redirectTo: 'address', pathMatch: 'full' },
    ]},
]
